import { useQuery } from '@tanstack/react-query';
import { graphql } from '../gql/gql';
import { useAuth0 } from '../auth/AuthProvider';
import { graphqlRequest, shouldRetryQuery } from '../utils/graphqlClient';
import type { MyBookingsQuery } from '../gql/graphql';

const myBookingsQuery = graphql(/* GraphQL */ `
  query myBookings {
    myBookings {
      tripId
      bookingId
      boatId
      boatPhoto
      boatName
      boatSlug
      routeName
      embarkationDate
      disembarkationDate
      guestCount
      diveCount
      arrivalAirport
      arrivalTime
      departureAirport
      departureTime
      departurePier
      returnPier
      bookingStatus
      isLeadGuest
      guestNumber
      leadGuestFullName
      leadGuestEmail
      leadGuestPhone
    }
  }
`);

const useGetPartnerBookings = () => {
  const { getAccessTokenSilently, isAuthenticated } = useAuth0();

  const { data, isLoading, error } = useQuery<MyBookingsQuery>({
    queryKey: ['partnerBookings'],
    queryFn: async () => {
      return graphqlRequest<MyBookingsQuery>(
        myBookingsQuery,
        undefined,
        getAccessTokenSilently,
      );
    },
    enabled: isAuthenticated,
    staleTime: 60000, // 1 minute
    retry: shouldRetryQuery,
  });

  return {
    bookings: data?.myBookings || [],
    isLoading,
    isError: !!error,
    error,
  };
};

export default useGetPartnerBookings;
